import React from 'react'
import PropTypes from 'prop-types'

import BusinessSection from '@/business-section'
import SectionIntegrationSlide from './section-integration-slide'

import img1 from './images/img1.png'
import img2 from './images/img2.png'
import img3 from './images/img3.png'

const SectionIntegration = ({ gray }) => {
  return (
    <BusinessSection
      title="Integration"
      subtitle="Share your content to media partners on web, apps, social, TV & stream"
      gray={gray}
    >
      <div className="flex flex-wrap mh--2">
        <SectionIntegrationSlide
          img={img1}
          text="1 create events on choicely.com"
          small
        />
        <SectionIntegrationSlide
          img={img2}
          text="2 integrate on your websites & native apps"
        />
        <SectionIntegrationSlide
          img={img3}
          text="3 share to social media, show live results on TV"
        />
      </div>
    </BusinessSection>
  )
}

SectionIntegration.propTypes = {
  gray: PropTypes.bool
}

export default SectionIntegration



// WEBPACK FOOTER //
// ./src/components/section-integration/section-integration.js